import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import plugins from '@/utils/plugins';
import { Toast } from 'vant';
Vue.use(Toast);
Vue.use(plugins);
Vue.config.productionTip = false;
// common.css
import '@/assets/css/common.css';
import 'amfe-flexible'; //引入rem自适应

//
import VueClipboard from 'vue-clipboard2';
VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);

//
import lodash from 'lodash';
Object.defineProperty(Vue.prototype, '$lodash', { value: lodash });
import Cookies from 'js-cookie';
router.beforeEach((to, from, next) => {
  // const token =
  //   'ypbqTiZdnUdyn/pO26An8ICMSUkkl2suZB9vAOugnwIVvKkybloXb5CIcbuDVROYJQNMV0A7C4kX2jwHtP/8vTe+7JbZ1rlyn264SoCA81o=';

  // store.commit(
  //   'setToken',
  //   'X8DEgjivKqxl1YVikT8SQM/UuxIQRRmtVDnC9ItYMFdPTfiwGX0r8yjlaDnVdmo/kXbqOo2NP0RoPNsnRDq1aTe+7JbZ1rlyn264SoCA81o=',
  // );
  // store.commit('setShopId', '1351471668219957248');
  // store.commit('setUserId', '1054682105667207168');

  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  document.documentElement.scrollTop = 0;
  if (to.query.user_token) {
    let token = decodeURIComponent(to.query.user_token);
    let shopId = decodeURIComponent(to.query.shop_id);
    let userId = decodeURIComponent(to.query.user_id);
    let userPhone = decodeURIComponent(to.query.user_phone);
    if (token) store.commit('setToken', token);
    if (shopId) store.commit('setShopId', shopId);
    if (userId) store.commit('setUserId', userId);
    if (userPhone) store.commit('setUserPhone', userPhone);
  }
  next();
});
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
